<template>
  <a-modal
    :title="title"
    v-model:visible="open"
    :confirm-loading="uploading"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin tip="上传中..." :spinning="uploading">
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">请将文件拖拽到此处上传❥(^_-)</p>
        <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
      </a-upload-dragger>
      <!--      <a-checkbox @change="handleCheckedUpdateSupport" :checked="updateSupport != 0">-->
      <!--        是否更新已经存在的用户数据-->
      <!--      </a-checkbox>-->
      <!-- <a @click="importTemplate" v-hasPermi="['system:dept:importTemplate']"
        >下载模板</a
      > -->
    </a-spin>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'

import { importData } from '@/api/system/dept'
import { showImportResult, isImportSuccessCode } from '@/utils/importResult'

export default {
  name: 'ImportExcel',
  props: {},
  components: {},
  data() {
    return {
      title: '用户导入',
      open: false,
      uploadStatus: '',
      fileList: [],
      // 是否禁用上传
      uploading: false,
      updateSupport: 0,
    }
  },
  created() {},
  computed: {},
  watch: {},
  methods: {
    /** 导入excel窗体关闭 */
    importExcelHandleCancel(e) {
      this.open = false
      this.fileList = []
      // 关闭后刷新列表
      $emit(this, 'ok')
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen(e) {
      this.open = true
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    /** 导入excel */
    importExcelHandleChange() {
      this.uploading = true
      const { fileList } = this
      const formData = new FormData()
      formData.append('file', fileList[0])
      formData.append('updateSupport', this.updateSupport)
      importData(formData)
        .then((response) => {
          if (isImportSuccessCode(response.code)) {
            this.fileList = []
            showImportResult(response)
            this.open = false
            $emit(this, 'ok')
          } else {
            this.$message.error(response.message)
            return
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },
    handleCheckedUpdateSupport() {
      this.updateSupport = this.updateSupport === 0 ? 1 : 0
    },
    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
  },
  emits: ['ok'],
}
</script>

<style>
/* Modal 按钮样式 - 全局样式确保生效 */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

/* 取消按钮样式 */
.ant-modal-footer .ant-btn-default {
  border-radius: 4px !important;
}

/* 确定按钮样式 */
.ant-modal-footer .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:active:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}
</style>
